import { combineReducers } from "redux";
import authReducer, { logout } from "./authReducer";
import loadingReducer from "./loadingReducer";
import menuReducer from "./menuReducer";
import roleReducer from "./roleReducer";
import customizationReducer from "./customizationReducer";

const appReducer = combineReducers({
    auth: authReducer,
    role: roleReducer,
    menu: menuReducer,
    loading: loadingReducer,
    customization: customizationReducer
});

export const rootReducer = (state, action) => {
    if (action.type === logout.type) {
        // This resets ALL slices
        state = undefined;
    }
    return appReducer(state, action);
};
